import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { MobileActionBar } from "@/components/site/MobileActionBar";
import Home from "@/pages/Home";
import PrivateLending from "@/pages/PrivateLending";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

const Site = () => (
  <>
    <Nav />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/private-lending" element={<PrivateLending />} />
    </Routes>
    <Footer />
    <MobileActionBar />
  </>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.085, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-obsidian text-ivory" data-testid="app-root">
      <div className="grain" aria-hidden="true" />
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Site />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: { background: "#1A2232", border: "1px solid rgba(212,175,55,0.3)", color: "#F8F9FA" },
        }}
      />
    </div>
  );
}
